import {
	SET_MODULES_DATA
} from './actions';

let defaultState = {
    modules: []
};

export default function inbox(state = defaultState, action) {
	switch (action.type) {
		case SET_MODULES_DATA:
			return { ...state, ...action.data };
		default:
			return state;
	}
}
